import {Component, OnInit, ViewChild, ViewEncapsulation, Renderer2, HostListener, ElementRef} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import 'core-js/es7/object';
import {KanbanService} from '../kanban.service';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {CourseDialogComponent} from './dialog-overview-example-dialog';
import {ProjetosService} from '../projetos.service';
import {UtilsService} from '../utils.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ChatService} from '../chat.service';
import { LoginService } from '../login.service';
import {interval} from 'rxjs';

@Component({
  selector: 'app-kanban',
  templateUrl: './kanban.component.html',
  styleUrls: ['./kanban.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: []
})
export class KanbanComponent implements OnInit {
  public projeto: any;
  public projeto_status: string = '';
  public _atividades: Object = new Object({'TO_DO': Array<Object>(), 'DOING': Array<Object>(), 'DONE': Array<Object>()});
  public totalTodo: number = 0;
  public totalDoing: number = 0;
  public totalDone: number = 0;
  public progressBar: boolean = true;
  public ver_cronograma: boolean = false;
  public modalAberta: boolean = false;
  public abrir_chat: boolean = false;
  public messages: any = [];
  public meses: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  public cronograma: any = {"TO_DO": [], "DOING": [], "DONE": [], anos: []};
  public cronograma_html: any;
  @ViewChild('tableCronograma') tableCronograma;

  //dataPrevistaInicio
  //dataPrevistaTermino
  descricao_projeto: String;
  dialogConfig = new MatDialogConfig();
  dialogRef: any;
  dadosProjeto: any = [];

  constructor(public route: ActivatedRoute,
    public router: Router,
    public dialog: MatDialog,
    private renderer: Renderer2,
    private service: ProjetosService,
    private sanitizer: DomSanitizer,
    private chat: ChatService,
    private loginServ: LoginService,
    private kanban: KanbanService) {
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl("http://ec2-18-231-61-4.sa-east-1.compute.amazonaws.com:8080");
  }

  ngOnInit() {
    this.projeto = this.route.snapshot.paramMap.get('id');
    this.descricao_projeto = this.route.snapshot.paramMap.get('descricao');
    this.service.getProjeto(this.projeto).subscribe((resp) => {
      console.log(resp);
      this.projeto_status = resp["status"];
      console.log(this.projeto_status);
      localStorage.setItem('kanban', JSON.stringify(resp));
    });
  }

  ngAfterViewInit() {
    this.getAtividades();

    interval(1000).subscribe(() => {
      this.getMessages();
    })
  }

  public isNumber(num?: any) {
    if (num != '' && Number(num) !== undefined) {
      return num;
    } else {
      return 0;
    }
  }

  addAnoCronograma(ano: number) {
    let item = this.cronograma.anos.find(tmpano => tmpano == ano);
    if (ano > 0 && item == undefined)
      this.cronograma.anos.push(ano);
  }

  getAtividades() {
    this.progressBar = true;
    this._atividades = {'TO_DO': [], 'DOING': [], 'DONE': []};
    this.cronograma = {"TO_DO": [], "DOING": [], "DONE": [], anos: [], atividades: []}

    this.kanban.getAtividades(this.route.snapshot.paramMap.get('id')).subscribe(resp => {
      this.progressBar = false;
      /*
      this.totalTodo = 0;
      this.totalDoing = 0;
      this.totalDone = 0;
      */

      Object.entries(resp).forEach(([key, atividade]) => {
        let dt_ini = String(atividade["dataInicio"]).split("/");
        let dt_fim = String(atividade["dataTermino"] !== null ? atividade["dataTermino"] : new Date().toLocaleDateString()).split("/");
        atividade["data_ini_dia"] = parseInt(dt_ini[0]);
        atividade["data_ini_mes"] = parseInt(dt_ini[1]);
        atividade["data_ini_ano"] = parseInt(dt_ini[2]);
        atividade["data_fim_dia"] = parseInt(dt_fim[0]);
        atividade["data_fim_mes"] = parseInt(dt_fim[1]);
        atividade["data_fim_ano"] = parseInt(dt_fim[2]);
        dt_ini = String(atividade["dataPrevistaInicio"]).split("/");
        atividade["data_prev_ini_dia"] = parseInt(dt_ini[0]);
        atividade["data_prev_ini_mes"] = parseInt(dt_ini[1]);
        atividade["data_prev_ini_ano"] = parseInt(dt_ini[2]);
        dt_fim = String(atividade["dataPrevistaTermino"]).split("/");
        atividade["data_prev_fim_dia"] = parseInt(dt_fim[0]);
        atividade["data_prev_fim_mes"] = parseInt(dt_fim[1]);
        atividade["data_prev_fim_ano"] = parseInt(dt_fim[2]);
        console.log("ativ", atividade["data_prev_fim_ano"]);

        atividade["percentualConclusao"] = Math.floor(atividade["percentualConclusao"]);

        atividade["transferindo"] = false;
        this._atividades[atividade.estagio].push(atividade);

        this.cronograma[atividade.estagio].push({
          "id": atividade.id,
          "descricao": atividade.descricao + " - (" + atividade["tarefas"].length + ")",
          "dataInicio": atividade["dataInicio"],
          "dataTermino": atividade["dataTermino"],
          "dataPrevistaInicio": atividade["dataPrevistaInicio"],
          "dataPrevistaTermino": (atividade["dataPrevistaTermino"] !== null ? atividade["dataPrevistaTermino"] : ""),
          "data_ini_dia": atividade["data_ini_dia"],
          "data_ini_mes": atividade["data_ini_mes"],
          "data_ini_ano": atividade["data_ini_ano"],
          "data_fim_dia": atividade["data_fim_dia"],
          "data_fim_mes": atividade["data_fim_mes"],
          "data_fim_ano": atividade["data_fim_ano"],
          "data_prev_ini_dia": atividade["data_prev_ini_dia"],
          "data_prev_ini_mes": atividade["data_prev_ini_mes"],
          "data_prev_ini_ano": atividade["data_prev_ini_ano"],
          "data_prev_fim_dia": atividade["data_prev_fim_dia"],
          "data_prev_fim_mes": atividade["data_prev_fim_mes"],
          "data_prev_fim_ano": atividade["data_prev_fim_ano"],
          classe: "",
          ref: ""
        });

        this.addAnoCronograma(atividade["data_ini_ano"]);
        this.addAnoCronograma(atividade["data_fim_ano"]);
        this.addAnoCronograma(atividade["data_prev_ini_ano"]);
        this.addAnoCronograma(atividade["data_prev_fim_ano"]);

        this.addTarefaCronograma(atividade);
      });
      /*
      this.totalTodo = Math.floor((this._atividades["TO_DO"].length > 0 ? this.totalTodo / this._atividades["TO_DO"].length : 0));
      this.totalDoing = Math.floor((this._atividades["DOING"].length > 0 ? this.totalDoing / this._atividades["DOING"].length : 0));
      this.totalDone = Math.floor((this._atividades["DONE"].length > 0 ? this.totalDone / this._atividades["DONE"].length : 0));
      */
      this.calculaPorcentagem();
      for (let ano in this.cronograma.anos) {
        /*this.cronograma.atividades.push('');*/

        for (let mes in this.meses)
          this.cronograma.atividades.push(this.meses[mes]);
      }
    });
  }

  calculaPorcentagem() {
    this.totalTodo = 0;
    this.totalDoing = 0;
    this.totalDone = 0;

    for (let estagio in this._atividades) {
      for (let ativ in this._atividades[estagio]) {
        if (estagio == 'TO_DO') {
          this.totalTodo += Math.floor(this._atividades[estagio][ativ]["percentualConclusao"]);
        } else if (estagio == 'DOING') {
          this.totalDoing += Math.floor(this._atividades[estagio][ativ]["percentualConclusao"]);
        } else if (estagio == 'DONE') {
          this.totalDone += Math.floor(this._atividades[estagio][ativ]["percentualConclusao"]);
        }
      }
    }

    this.totalTodo = Math.floor((this._atividades["TO_DO"].length > 0 ? this.totalTodo / this._atividades["TO_DO"].length : 0));
    this.totalDoing = Math.floor((this._atividades["DOING"].length > 0 ? this.totalDoing / this._atividades["DOING"].length : 0));
    this.totalDone = Math.floor((this._atividades["DONE"].length > 0 ? this.totalDone / this._atividades["DONE"].length : 0));
  }

  private addTarefaCronograma(atividade) {
    Object.entries(atividade["tarefas"]).forEach(([key2, tarefa]) => {
      let dt_ini = String(atividade["dataInicio"]).split("/");
      let dt_fim = String(tarefa["dataTermino"]).split("/");
      tarefa["data_ini_dia"] = parseInt(dt_ini[0]);
      tarefa["data_ini_mes"] = parseInt(dt_ini[1]);
      tarefa["data_ini_ano"] = parseInt(dt_ini[2]);
      tarefa["data_prev_ini_dia"] = parseInt(dt_ini[0]);
      tarefa["data_prev_ini_mes"] = parseInt(dt_ini[1]);
      tarefa["data_prev_ini_ano"] = parseInt(dt_ini[2]);
      tarefa["data_fim_dia"] = parseInt(dt_fim[0]);
      tarefa["data_fim_mes"] = parseInt(dt_fim[1]);
      tarefa["data_fim_ano"] = parseInt(dt_fim[2]);

      dt_fim = String((tarefa["dataPrevistaTermino"] !== null ? tarefa["dataPrevistaTermino"] : new Date().toLocaleDateString())).split("/");
      tarefa["data_prev_fim_dia"] = dt_fim[0];
      tarefa["data_prev_fim_mes"] = dt_fim[1];
      tarefa["data_prev_fim_ano"] = dt_fim[2];

      this.cronograma[atividade.estagio].push({
        "descricao": tarefa["descricao"],
        "dataInicio": atividade["dataInicio"],
        "dataTermino": atividade["dataTermino"],
        "dataPrevistaTermino": (atividade["dataPrevistaTermino"] !== null ? atividade["dataPrevistaTermino"] : ""),
        "data_ini_dia": tarefa["data_ini_dia"],
        "data_ini_mes": tarefa["data_ini_mes"],
        "data_ini_ano": tarefa["data_ini_ano"],
        "data_fim_dia": tarefa["data_fim_dia"],
        "data_fim_mes": tarefa["data_fim_mes"],
        "data_fim_ano": tarefa["data_fim_ano"],
        "data_prev_ini_dia": tarefa["data_prev_ini_dia"],
        "data_prev_ini_mes": tarefa["data_prev_ini_mes"],
        "data_prev_ini_ano": tarefa["data_prev_ini_ano"],
        "data_prev_fim_dia": tarefa["data_prev_fim_dia"],
        "data_prev_fim_mes": tarefa["data_prev_fim_mes"],
        "data_prev_fim_ano": tarefa["data_prev_fim_ano"],
        classe: "hide",
        ref: atividade.id
      });

      this.addAnoCronograma(tarefa["data_ini_ano"]);
      this.addAnoCronograma(tarefa["data_fim_ano"]);
      this.addAnoCronograma(tarefa["data_prev_ini_ano"]);
      this.addAnoCronograma(tarefa["data_prev_fim_ano"]);
    });
  }

  public toggleCronograma(ativ) {
    if (ativ.toggleCronograma == undefined || ativ.toggleCronograma == false) {
      ativ.toggleCronograma = true;
      eval("document.querySelectorAll('tr[ref=\"" + ativ.id + "\"]').forEach(function(a){ a.className = 'linhaCronograma'; })");
    } else {
      ativ.toggleCronograma = false;
      eval("document.querySelectorAll('tr[ref=\"" + ativ.id + "\"]').forEach(function(a){ a.className = 'hide'; })");
    }
  }

  private delay(ms: number): Promise<boolean> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, ms);
    });
  }

  public verCronograma() {
    this.abrir_chat = false;

    if (this.ver_cronograma)
      this.ver_cronograma = false;
    else {
      this.ver_cronograma = true;
      eval("window.M.FormSelect.init(document.querySelectorAll('select'), {});");
      //this.montarCronogramaHtml();
      this.delay(100).then(() => {
        this.montarCronograma();
      });
    }
  }

  public montarCronograma() {
    var idx = 0;
    var trAno = this.renderer.createElement('tr');
    var trMeses = this.renderer.createElement('tr');
    var tbody = this.renderer.createElement('tbody');

    for (let ano in this.cronograma.anos) {
      if (idx == 0) {
        var thAno = this.renderer.createElement('td');
        thAno.setAttribute('class', 'center ano');
        thAno.style.color = 'white';
        thAno.style.width = '250px';
        thAno.style.height = '40px';
        thAno.style.display = '';
        this.renderer.appendChild(trAno, thAno);

        let td = this.renderer.createElement('td');
        td.style.color = 'white';
        td.setAttribute('class', 'center ano');
        td.style.width = '250px';
        td.style.height = '40px';
        td.style.display = '';
        this.renderer.appendChild(trMeses, td);
      }

      var thAno = this.renderer.createElement('td');

      /* Deixa apenas o primeiro ano aberto, os outros ele deixa fechado */
      if (Number(ano) > 0) {
        thAno.setAttribute('colspan', '1');
        thAno.setAttribute('toggleAno', 'false');
        thAno.style.width = '80px';
      } else {
        thAno.setAttribute('colspan', '12');
        thAno.setAttribute('toggleAno', 'true');
        thAno.style.width = '600px';
      }
      thAno.style.height = '40px';
      thAno.style.display = '';
      //thAno.style.borderLeft = '1px solid orange';

      thAno.style.cursor = 'pointer';
      thAno.setAttribute('data', this.cronograma.anos[ano]);

      if (this.cronograma.anos.length > 0)
        this.renderer.listen(thAno, 'click', (event) => {
          this.abrirAnoCronograma(event.toElement);
        });

      thAno.setAttribute('class', 'center ano');
      thAno.innerHTML = this.cronograma.anos[ano] + '<i style="float:right;font-size:18px;' + (Number(ano) == 0 ? 'display:none;' : '') + '" class="material-icons">compare_arrows</i>';
      thAno.style.color = 'white';
      this.renderer.appendChild(trAno, thAno);

      for (let mes in this.meses) {
        let td = this.renderer.createElement('td');
        td.innerHTML = this.meses[mes];
        td.setAttribute('class', 'center mes');
        td.style.width = '80px';
        td.style.height = '40px';
        td.style.display = '';

        /* Deixa apenas o primeiro ano aberto, os outros ele deixa fechado */
        if (Number(ano) > 0 && Number(mes) > 0) {
          td.style.display = 'none';
        }

        if (Number(mes) > 0)
          td.setAttribute('ref', this.cronograma.anos[ano]);

        td.style.color = 'white';

        //if (this.meses[mes] == 1) 
        //td.style.borderLeft = '1px solid orange';

        this.renderer.appendChild(trMeses, td);
      }

      idx++;
    }

    idx = 0;
    for (let ativ in this.cronograma) {
      if (ativ == 'TO_DO' || ativ == 'DOING' || ativ == 'DONE') {
        for (let item in this.cronograma[ativ]) {
          var trLinha = this.renderer.createElement('tr');

          if (this.cronograma[ativ][item]["classe"] !== '') {
            trLinha.setAttribute('class', 'linha hide');
            trLinha.setAttribute('ref', this.cronograma[ativ][item]["ref"]);
          } else trLinha.setAttribute('class', 'linha');

          idx = 0;
          for (let ano in this.cronograma.anos) {
            if (idx == 0) {
              let td = this.renderer.createElement('td');
              let span = this.renderer.createElement('span');
              let text = this.renderer.createText(this.cronograma[ativ][item]["descricao"]);
              this.renderer.appendChild(span, text);
              this.renderer.appendChild(td, span);
              this.renderer.listen(span, 'click', (event) => console.log(event));
              td.style.width = '250px';
              td.style.cursor = 'pointer';
              td.style.display = 'table-cell';
              this.renderer.listen(span, 'click', () => {
                this.toggleCronograma(this.cronograma[ativ][item]);
              })
              this.renderer.appendChild(trLinha, td);
            }

            for (let mes in this.meses) {
              let tdLinha = this.renderer.createElement('td');
              tdLinha.style.width = '50px';
              tdLinha.setAttribute('ref', this.cronograma.anos[ano]);

              /* Deixa apenas o primeiro ano aberto, os outros ele deixa fechado */
              if (Number(ano) > 0 && Number(mes) > 0) {
                tdLinha.style.display = 'none';
              } // else tdLinha.style.display = 'inline-block';

              console.log("atividade", this.cronograma[ativ][item]);
              let span1 = this.renderer.createElement('span');
              span1.setAttribute('title', 'Data de in�cio: ' + this.cronograma[ativ][item]["dataInicio"] + " - Previs�o de t�rmino: " + this.cronograma[ativ][item]["dataPrevistaTermino"]);
              span1.setAttribute('class', this.cronogramaCores('prev', this.cronograma[ativ][item], parseInt(this.meses[mes]), parseInt(this.cronograma.anos[ano])));
              this.renderer.appendChild(tdLinha, span1);

              let span2 = this.renderer.createElement('span');
              span2.setAttribute('title', 'Data de in�cio: ' + this.cronograma[ativ][item]["dataInicio"] + " - Data de t�rmino: " + (this.cronograma[ativ][item]["dataTermino"] !== null ? this.cronograma[ativ][item]["dataTermino"] : "Em andamento"));
              span2.setAttribute('class', this.cronogramaCores('atual', this.cronograma[ativ][item], parseInt(this.meses[mes]), parseInt(this.cronograma.anos[ano])));
              this.renderer.appendChild(tdLinha, span2);

              if (this.meses[mes] == 1)
                tdLinha.style.borderLeft = '1px solid orange';

              this.renderer.appendChild(trLinha, tdLinha);
            }
            idx++;
            tbody.appendChild(trLinha);
          }
        }
      }
    }

    this.renderer.appendChild(this.tableCronograma.nativeElement, trAno);
    this.renderer.appendChild(this.tableCronograma.nativeElement, trMeses);
    this.renderer.appendChild(this.tableCronograma.nativeElement, tbody);
  }

  @HostListener('window:scroll', ['$event'])
  scrollHandler($event) {
    //console.log($event);
  }

  abrirAnoCronograma(elemAno) {
    let vdisplay = '';

    if (elemAno.getAttribute('toggleano') == "false") {
      elemAno.setAttribute('toggleano', 'true');
      elemAno.setAttribute('colspan', '12');
      elemAno.style.width = '600px';
      elemAno.querySelector('i').style.display = 'none';
    } else {
      vdisplay = 'none';
      elemAno.setAttribute('toggleano', 'false');
      elemAno.setAttribute('colspan', '1');
      elemAno.style.width = '50px';
      elemAno.querySelector('i').style.display = '';
    }

    document.querySelectorAll('td[ref="' + elemAno.getAttribute('data') + '"]').forEach((elem) => {
      elem["style"]["display"] = vdisplay;
    });
  }

  cronogramaCores(tipo: string, ativ: any, mes: number, ano: number): String {
    let dt1 = new Date(ano, mes, 1).getTime();

    switch (tipo) {
      case "prev":
        let dt_ini_prev = new Date(ativ.data_prev_ini_ano, ativ.data_prev_ini_mes, 1).getTime();
        let dt_fim_prev = new Date(ativ.data_prev_fim_ano, ativ.data_prev_fim_mes, 1).getTime();

        /* dentro do per�odo */
        //if ((mes >= parseInt(ativ.data_prev_ini_mes) && ano >= parseInt(ativ.data_prev_ini_ano)) && (parseInt(ativ.data_prev_fim_mes) <= mes && ano <= parseInt(ativ.data_prev_fim_ano) )) {
        if (dt1 >= dt_ini_prev && dt1 <= dt_fim_prev) {
          console.log(ano, parseInt(ativ.data_prev_ini_ano), ativ, ativ.data_prev_fim_ano);
          /* in�cio do per�odo */
          if (ano == parseInt(ativ.data_prev_ini_ano) && mes == parseInt(ativ.data_prev_ini_mes))
            return 'cronogramaLinha cronogramaDentroData cronogramaAzul cronogramaBorderIni';
          /* final do per�odo */
          else if (ano == parseInt(ativ.data_prev_fim_ano) && mes == parseInt(ativ.data_prev_fim_mes))
            return 'cronogramaLinha cronogramaDentroData cronogramaAzul cronogramaBorderFim';
          /* dentro do per�odo */
          else if (dt1 >= dt_ini_prev && dt1 <= dt_fim_prev)
            return 'cronogramaLinha cronogramaDentroData cronogramaAzul';
          /* Fora do Per�odo do come�o do m�s do primeiro ano */
        } else if (ano == parseInt(ativ.data_prev_ini_ano) && mes < parseInt(ativ.data_prev_ini_mes))
          return 'cronogramaLinha cronogramaForaData cronogramaCinza';
        break;
      case "atual":
        let dt_ini = new Date(ativ.data_ini_ano, ativ.data_ini_mes, 1).getTime();
        let dt_fim = new Date(ativ.data_fim_ano, ativ.data_fim_mes, 1).getTime();

        /* dentro do per�odo */
        //if ((mes >= parseInt(ativ.data_ini_mes)) && (mes <= parseInt(ativ.data_fim_mes))) {
        if (dt1 >= dt_ini && dt1 <= dt_fim) {
          /* in�cio do per�odo */
          if (ano == parseInt(ativ.data_ini_ano) && mes == parseInt(ativ.data_ini_mes))
            return 'cronogramaLinha cronogramaDentroData cronogramaVermelho cronogramaBorderIni';
          /* final do per�odo */
          else if (ano == parseInt(ativ.data_fim_ano) && mes == parseInt(ativ.data_fim_mes))
            return 'cronogramaLinha cronogramaDentroData cronogramaVermelho cronogramaBorderFim';
          /* final do per�odo */
          else if (dt1 >= dt_ini && dt1 <= dt_fim)
            return 'cronogramaLinha cronogramaDentroData cronogramaVermelho';
          /* Fora do Per�odo do come�o do m�s do primeiro ano */
        } else if (ano == parseInt(ativ.data_ini_ano) && mes < parseInt(ativ.data_ini_mes) && isNaN(ativ.data_ini_mes) !== true)
          return 'cronogramaLinha cronogramaForaData cronogramaCinza';

        break;
    }

    return 'cronogramaLinha cronogramaForaData cronogramaTransparente';
  }

  safeSrc: SafeResourceUrl;
  safeHTML() {
    //this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl();
  }

  abrirChat() {
    

    this.ver_cronograma = false;
    //window.open('http://ec2-18-231-61-4.sa-east-1.compute.amazonaws.com:8080/', '_blank');

    if (this.abrir_chat)
      this.abrir_chat = false;
    else this.abrir_chat = true;
  }

  public sendMessage(sendMessageText: any) {
    this.chat.setChat({ idProjeto: this.projeto, idUsuario: this.loginServ.getUsuario("id"), idUsuarioDestino: 50, mensagem: sendMessageText } ).subscribe((resp) => {

      this.getMessages();
    });
  }

  getMessages() {
    //this.messages = [];
    this.chat.getChat(this.projeto).subscribe((resp) => {
      this.messages = resp;
    })
  }
  getDateFromTimestamp(m){
    let date: Date = new Date(m); 
    return date.toDateString;
  }

  public verTarefas(taf) {
    if (document.getElementById('tarefas_' + taf.id).style.display == 'block')
      document.getElementById('tarefas_' + taf.id).style.display = 'none';
    else document.getElementById('tarefas_' + taf.id).style.display = 'block';
  }

  private async isStatus(items) {
    Object.entries(items).forEach(([estagio, value]) => {
      Object.entries(value).forEach(([key2, value2]) => {
        if (estagio !== value2.estagio) {
          this.kanban.setEstagio(this.route.snapshot.paramMap.get('id'), value2.id, estagio).subscribe((resp) => {

            if (resp != undefined)
              this._atividades[resp["estagio"]].forEach((ativ, index) => {
                if (ativ.id == resp["id"])
                  this._atividades[resp["estagio"]][index] = resp;
                this._atividades[resp["estagio"]][index]["transferindo"] = false;
              });

            this.calculaPorcentagem();
          });
        }
      })
    })
  }

  excluirAtividade($event, item) {
    if ($event == true) {
      this.progressBar = true;
      console.log(item);
      this.kanban.removerAtividade(this.projeto, item.id).subscribe(() => {
        this.progressBar = false;
        this.getAtividades();
      }, () => {

        this.progressBar = false;
      })
    }
  }

  public TO_DO(items: any): any[] {
    console.log(items);
    if (items.TO_DO !== undefined) {
      return items.TO_DO
      //console.log('TODO', items);
      //return items.filter(elem => elem.estagio == 'TO_DO');
    } else return Array<Object>();
  }

  public DOING(items: any): any[] {
    if (items.DOING !== undefined) {
      return items.DOING;
      //console.log('DOING', items);
      //return items.filter(elem => elem.estagio == 'DOING');
    } else {
      return Array<Object>();
    }
  }

  public DONE(items: any): any[] {
    if (items.DONE !== undefined) {
      return items.DONE;
      //console.log('DONE', items);
      //return items.filter(elem => elem.estagio == 'DONE');
    } else {
      return Array<Object>();
    }
  }

  async drop(event: CdkDragDrop<string[]>) {
    if (event.item.data === 'Try to move me') {
      console.log("this isn't happening today");
      return;
    }
    let proj = JSON.parse(localStorage.getItem('kanban'));

    if (proj.userAdmin == false) {
      let data = proj.dataPrevistaTermino.split('/');
      data = new Date(data[2], data[1] - 1, data[0]);
      data.setHours(0, 0, 0, 0);
      let dataHoje = new Date();
      dataHoje.setHours(0, 0, 0, 0);

      if (data.getTime() !== dataHoje.getTime() && dataHoje > data) {
        UtilsService.alerta('Data de t�rmino dessa atividade expirada!', 'erro');
        return;
      }
    }
    try {
      if (event.previousContainer === event.container) {
        await moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else {
        event.previousContainer.data[event.previousIndex]["transferindo"] = await true;
        await transferArrayItem(event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex);
        await this.isStatus(this._atividades);
      }
    } catch (error) {
      console.log(error);
      this.delay(1000).then(() => {
        this.drop(event);
      });
    }

  }

  @HostListener('window:keyup.esc') onKeyUp() {
    this.dialogRef.close();
  }

  openDialog(item?: any) {
    this.modalAberta = true;

    if (this.dialogRef !== undefined)
      this.dialogRef.close();

    if (item !== null) {
      item["projeto"] = this.projeto;
    } else {
      item = new Object({'novocadastro': "true", 'projeto': this.projeto});
    }

    item["dadosProjeto"] = JSON.parse(localStorage.getItem('kanban'));

    this.dialogConfig.autoFocus = false;
    this.dialogConfig.data = item ? item : '';
    this.dialogConfig.width = '100vw';
    this.dialogConfig.maxWidth = '100vw';
    this.dialogConfig.maxHeight = '100vh';
    this.dialogConfig.height = '100vh';
    this.dialogConfig.disableClose = false;
    this.dialogConfig.hasBackdrop = false;
    this.dialogConfig.closeOnNavigation = true;
    /*dialogConfig.width = '250px'; */

    this.dialogRef = this.dialog.open(CourseDialogComponent, this.dialogConfig);
    eval('document.getElementsByClassName("cdk-overlay-container")[0].style.display = "";');

    this.dialogRef.backdropClick().subscribe(() => {
      // Close the dialog
      this.dialogRef.close();
    })

    this.dialogRef.afterClosed().subscribe((result) => {
      this.modalAberta = false;
      this.dialogRef.close();
      this.getAtividades();
      eval('document.getElementsByClassName("cdk-overlay-container")[0].style.display = "none";');

      if (result == undefined) {
        this.ngAfterViewInit();
        return;
      }

      var alteracao: boolean = false;
      if (result != undefined && result.estagio !== undefined) {
        this._atividades[result.estagio].forEach((ativ, index) => {
          if (ativ.id == result.id) {
            this._atividades[result.estagio][index] = result;
            alteracao = true;
          }
        });
        /*
        Object.entries(this.cronograma).forEach(function([key, tarefa]) {
          for (let item in tarefa) {
            console.log(tarefa[item]);
          }
        });
        */
      }
    });
  }

  public modalOptions: Materialize.ModalOptions = {
    dismissible: false, // Modal can be dismissed by clicking outside of the modal
    opacity: .5, // Opacity of modal background
    inDuration: 300, // Transition in duration
    outDuration: 200, // Transition out duration
    startingTop: '10px', // Starting top style attribute
    endingTop: '10%', // Ending top style attribute
    ready: (modal, trigger) => { // Callback for Modal open. Modal and trigger parameters available.
    },
    complete: () => { } // Callback for Modal close
  };
}